import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { createPath, ROUTE } from 'utils/Routing';
import './Pagination.css';

type PaginationTypes = {
  totalPosts: number;
  setIndexOfFirstPost: Function;
  contentPerPage: number;
};

const Pagination = ({ totalPosts, setIndexOfFirstPost, contentPerPage }: PaginationTypes) => {
  const { currentPage }: { currentPage: string } = useParams();
  const pageNumbers: number[] = [];
  for (let i = 1; i <= Math.ceil(totalPosts / contentPerPage); i++) {
    pageNumbers.push(i);
  }

  const pageNum: number = !(
    Number.isNaN(Number.parseInt(currentPage, 10)) || Number.parseInt(currentPage, 10) > pageNumbers.length
  )
    ? Number.parseInt(currentPage, 10)
    : pageNumbers[pageNumbers.length - 1];
  const indexOfLastPost = pageNum * contentPerPage;
  const indexOfFirstPost = indexOfLastPost - contentPerPage;

  useEffect(() => {
    setIndexOfFirstPost(indexOfFirstPost);
  }, [setIndexOfFirstPost, indexOfFirstPost, currentPage]);

  return (
    <div className='pagination'>
      {pageNumbers.map((number) => (
        <Link
          key={number}
          to={createPath({ path: ROUTE.GAME_LIST, params: { currentPage: number } })}
          className={`button ${pageNum === number ? 'active' : undefined}`}
        >
          {number}
        </Link>
      ))}
    </div>
  );
};

export default React.memo(Pagination);
